<template>
  <v-dropdown :triggers="['click']" :positioning-disabled="true">
    <a class="flex flex-col items-center text-secondary opacity-75">
      <LayoutElementsIcon :name="item.icon || (icons && icons[item.id])" class="mb-1" />
      <span class="text-center text-[0.7rem] line-clamp-1 text-clip px-px">{{ item.name || item.icon }}</span>
    </a>

    <template #popper>
      <div class="border-b">
        <p class="text-secondary opacity-80 text-xs line-clamp-1 text-clip p-4">{{ item.name || item.icon }}</p>
      </div>
      <ul class="p-2 space-y-2 text-sm">
        <li v-for="(child, key) in item.children" :key="`${key}-${child.type}`">
          <LayoutElementsMenuItem :item="child" icon info />
        </li>
      </ul>
    </template>
  </v-dropdown>
</template>

<script setup lang="ts">
interface Props {
  item: {
    id: '/book-now' | '/timetable' | '/last-minute' | '/gift' | '/pass' | '/gallery' | '/reviews' | '/customer'
    name: string
    type: string
    slug: string
    icon: string
    information: string
    children: any[]
  }
  icons?: Record<string, string>
}

defineProps<Props>()
</script>
